module.exports = __webpack_public_path__ + "img/xuanze.1912e102.png";